// Helpdesk font list — mirrors the appearance tab's FONT_META (key → family).
// Kept separate so public help-center pages don't pull the settings route
// chunk into their bundle. Keys are what kb_settings.title_font/body_font store.

export interface KbFontMeta {
  key: string;
  label: string;
  family: string;
  /** Google Fonts URL family parameter, when the font needs lazy loading. */
  googleSpec?: string;
}

export const KB_FONTS: KbFontMeta[] = [
  { key: 'system', label: 'System Default', family: 'ui-sans-serif, system-ui, -apple-system, sans-serif' },
  { key: 'inter', label: 'Inter', family: 'Inter, sans-serif', googleSpec: 'Inter:wght@400;500;600;700;800' },
  { key: 'geist', label: 'Geist', family: 'Geist, sans-serif', googleSpec: 'Geist:wght@400;500;600;700' },
  { key: 'figtree', label: 'Figtree', family: 'Figtree, sans-serif', googleSpec: 'Figtree:wght@400;500;600;700' },
  { key: 'lato', label: 'Lato', family: 'Lato, sans-serif', googleSpec: 'Lato:wght@400;700' },
  { key: 'lexend', label: 'Lexend', family: 'Lexend, sans-serif', googleSpec: 'Lexend:wght@400;500;600;700' },
  { key: 'manrope', label: 'Manrope', family: 'Manrope, sans-serif', googleSpec: 'Manrope:wght@400;500;600;700;800' },
  { key: 'mulish', label: 'Mulish', family: 'Mulish, sans-serif', googleSpec: 'Mulish:wght@400;500;600;700' },
  { key: 'nunito', label: 'Nunito', family: 'Nunito, sans-serif', googleSpec: 'Nunito:wght@400;600;700' },
  { key: 'open_sans', label: 'Open Sans', family: 'Open Sans, sans-serif', googleSpec: 'Open+Sans:wght@400;500;600;700' },
  { key: 'outfit', label: 'Outfit', family: 'Outfit, sans-serif', googleSpec: 'Outfit:wght@400;500;600;700' },
  { key: 'golos_text', label: 'Golos Text', family: 'Golos Text, sans-serif', googleSpec: 'Golos+Text:wght@400;500;600;700' },
  { key: 'instrument_sans', label: 'Instrument Sans', family: 'Instrument Sans, sans-serif', googleSpec: 'Instrument+Sans:wght@400;500;600;700' },
  { key: 'gabarito', label: 'Gabarito', family: 'Gabarito, sans-serif', googleSpec: 'Gabarito:wght@400;500;600;700' },
  { key: 'lora', label: 'Lora', family: 'Lora, serif', googleSpec: 'Lora:wght@400;500;600;700' },
  { key: 'playfair', label: 'Playfair Display', family: 'Playfair Display, serif', googleSpec: 'Playfair+Display:wght@400;500;600;700;800' },
  { key: 'neuton', label: 'Neuton', family: 'Neuton, serif', googleSpec: 'Neuton:wght@400;700' },
  { key: 'slabo', label: 'Slabo 13px', family: 'Slabo 13px, serif', googleSpec: 'Slabo+13px' },
  { key: 'enriqueta', label: 'Enriqueta', family: 'Enriqueta, serif', googleSpec: 'Enriqueta:wght@400;500;600;700' },
  { key: 'oswald', label: 'Oswald', family: 'Oswald, sans-serif', googleSpec: 'Oswald:wght@400;500;600' },
  { key: 'fira_code', label: 'Fira Code', family: 'Fira Code, monospace', googleSpec: 'Fira+Code:wght@400;500;600' },
  { key: 'fira_sans_condensed', label: 'Fira Sans Condensed', family: 'Fira Sans Condensed, sans-serif', googleSpec: 'Fira+Sans+Condensed:wght@400;500;600;700' },
  { key: 'google_sans', label: 'Google Sans', family: 'Google Sans, sans-serif' },
  { key: 'google_sans_code', label: 'Google Sans Code', family: 'Google Sans Code, monospace' },
  { key: 'lilex', label: 'Lilex', family: 'Lilex, monospace', googleSpec: 'Lilex' },
  { key: 'gochi_hand', label: 'Gochi Hand', family: 'Gochi Hand, cursive', googleSpec: 'Gochi+Hand' },
  { key: 'sn_pro', label: 'SN Pro', family: 'SN Pro, sans-serif' },
  { key: 'suse', label: 'SUSE', family: 'SUSE, sans-serif', googleSpec: 'SUSE:wght@400;500;600;700' },
];

export function kbFontFamily(key: string | null | undefined): string | undefined {
  if (!key || key === 'system') return undefined;
  return KB_FONTS.find((f) => f.key === key)?.family;
}

export function kbFontLabel(key: string | null | undefined): string {
  if (!key) return 'Default';
  return KB_FONTS.find((f) => f.key === key)?.label ?? 'Default';
}
